import { ProductPriceTagProps, ProductPriceTagStateProps } from '../../types/components/products/ProductPriceTag';
import { SubscriptionDetail } from '../../types/api/SubscriptionTypes';
import { ApplicationState } from '../../types/state/storeTypes';

import { connect } from 'react-redux';
import subscriptionHelpers from '../../helpers/subscriptionHelpers';
import creditsHelpers from '../../helpers/creditsHelpers';

import Image from 'next/image';

const ProductPriceTag: React.FC<ProductPriceTagProps> = (props) => {
  const { product, subscription, className, collection } = props;
  const { isLegacy } = subscriptionHelpers;
  const { getCreditPriceTextFor } = creditsHelpers;

  // Edge cases where credit tag shouldn't be rendered
  if (collection?.library.id == 2) return <></>;
  if (isLegacy(subscription)) return <></>;
  if (product.free_product) return <></>;
  if (collection && collection?.free_product) return <></>;
  if (collection && collection?.membership_tier == 'silver') return <></>;

  return (
    <div
      cy-test-id={`product-${product.id}-price-tag`}
      className={`py-[3px] px-2.5 rounded-[3px] bg-gray-800 text-white flex flex-row gap-1 ${className || ''}`}
    >
      <Image
        src="/img/pricing/credits-icon.png"
        width={15}
        height={15}
        alt="credits icon"
      />
      <span cy-test-id="amount" className="text-12 leading-16 capitalize">{getCreditPriceTextFor(product)}</span>
    </div>
  )
}

const mapStateToProps = (state: ApplicationState): ProductPriceTagStateProps => ({
  subscription: state.auth.subscription as SubscriptionDetail,
});

export default connect(mapStateToProps)(ProductPriceTag);
